import React from "react";
import {Document, Page, Text, View, StyleSheet, Font, Svg, Path, Image} from "@react-pdf/renderer";
import BlockContent from "@sanity/block-content-to-react";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "~utils/sanityClient";

const builder = imageUrlBuilder(sanityClient);

Font.register({
  family: "BasisGrotesque",
  src: "/fonts/basis-grotesque-medium-pro.woff",
  fontStyle: "normal",
  fontWeight: "normal",
});

const Logo = () => (
  <Svg width={120} viewBox="0 0 404 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path
      d="M98.32 0.12H125.43V1.42L121.38 1.55C116.84 1.74 115.77 2.35 115.77 17.18V56.06C115.77 70.89 116.84 71.5 121.38 71.69L125.43 71.82V73.13H98.32V71.82L101.76 71.69C106.3 71.5 107.37 70.89 107.37 56.06V17.18C107.37 2.35 106.3 1.74 101.76 1.55L98.32 1.42V0.12ZM167.8 31C158.48 26.52 149.68 22.31 149.68 12.28C149.68 5.48 154.51 1.42 162.61 1.42C171.61 1.42 179.23 7.56 182.05 17.07L183.29 21H184.45V0H183.52L183.38 0.18C181.69 2.23 179.26 5 177.46 5C176.303 4.86857 175.212 4.39112 174.33 3.63C170.78 1.25882 166.599 0.00817055 162.33 0.04C150.27 0.04 141.52 7.93 141.52 18.79C141.52 31 151.74 35.79 161.62 40.39C170.93 44.73 179.69 48.82 179.69 58.72C179.69 67.07 174.01 71.86 164.09 71.86C149.42 71.86 143.41 60.24 141.09 53.31L139.73 49.15H138.58V73.2H139.52L139.66 73.01C142.57 69.29 144.66 67.62 146.5 67.62C147.71 67.62 148.55 68.1 150.05 69.1C154.216 71.8783 159.134 73.3095 164.14 73.2C178.39 73.2 188.36 65.2 188.36 53.73C188.36 40.85 177.9 35.83 167.79 30.97L167.8 31ZM402.54 71.64C398.54 71.14 397.48 69.56 391.4 54.74L369.27 0.63L369.14 0.31H367.31L363.31 10.74L381 56.25C384 63.91 385.77 68.53 384.55 70.4C384.02 71.18 382.9 71.57 381 71.63L377.79 71.75V73H403.86V71.79L402.54 71.64ZM347.29 63.74C347.29 62.27 347.4 60.88 347.52 59.45L347.61 59.18C347.92 55.39 349.26 50.01 349.17 49.11C349.08 48.21 348.61 49.11 348.61 49.11L345.87 56C340 70.43 338 71.31 334.68 71.63L333.08 71.77V73H355.36V71.75L352.69 71.63C348.19 71.35 347.29 68.4 347.29 63.74ZM47.86 41.19L22.18 0.25H3.4V1.55L5.79 1.68C8.23 1.78 9.79 2.13 10.79 3.68C10.79 3.68 12.18 5.49 13.25 6.99L41.86 51.74H43.86L68.89 5.92V56C68.89 70.77 67.8 71.38 63.2 71.58L60.48 71.7V73H85.85V71.73L83.13 71.61C78.53 71.41 77.44 70.8 77.44 56.03V17.27C77.44 2.48 78.53 1.87 83.13 1.68L85.85 1.56V0.25H70.49L47.86 41.19ZM13.22 62.07C12.4447 58.0844 11.9303 54.0525 11.68 50C11.68 48.67 11.31 48.48 11.31 48.48C11.31 48.48 10.96 48.67 10.94 50C10.6856 54.2886 10.1208 58.5531 9.25 62.76C8.86035 64.5867 8.25965 66.362 7.46 68.05C6.85764 69.0916 6.0078 69.9687 4.98568 70.6036C3.96356 71.2385 2.8007 71.6116 1.6 71.69L0 71.83V73.1H24.3V71.82L21.62 71.69C16.95 71.12 14.54 66.96 13.22 62.07ZM247.92 1.49L250.59 1.62C257.7 2 261 16.32 261 25.87V48C261 61.58 251.81 70.37 237.59 70.37C222.84 70.37 214.39 62.18 214.39 47.89V17C214.39 2.44 215.46 1.84 219.99 1.66L222.66 1.53V0.21H195.56V1.49L198.24 1.62C202.78 1.81 203.85 2.4 203.85 16.96V48C203.85 63.44 215.33 73 233.85 73C251.22 73 262.45 63.18 262.45 48V25.87C262.45 9.81 265.08 2.27 270.36 1.8L273.52 1.66V0.21H247.92V1.49ZM315.67 60.49L315.32 59.89C313.97 57.6 311.18 52.83 310.02 50.99C305.55 43.99 300.59 40.38 291.29 37.54C295.573 37.5882 299.833 36.912 303.89 35.54C312.18 32.54 317.13 26.31 317.13 18.87C317.13 7.55 307.73 0.24 293.13 0.24H277.64V1.65H293.17C300.85 1.65 305.24 8 305.24 19.06C305.24 30.96 301.6 36.06 293.07 36.06H279.39V37.49H282.94C290.01 37.49 292.02 39.17 298.39 50.35C299.56 52.35 301.21 55.55 302.81 58.63C303.81 60.56 304.81 62.45 305.62 63.98C307.83 68.07 309.08 70.68 310.09 72.8L310.23 73.09H328.74V71.79L326.36 71.66C322.6 71.45 319.43 66.66 315.67 60.5"
      fill="currentColor"
    />
  </Svg>
);

const smallCaps = {
  fontFamily: "BasisGrotesque",
  textTransform: "uppercase",
  fontSize: 7,
  letterSpacing: "0.5px",
};

const h1 = {
  fontFamily: "BasisGrotesque",
  fontSize: 12,
};

const h2 = {
  fontFamily: "BasisGrotesque",
  fontSize: 9,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginTop: 7,
  marginBottom: 5,
};

const body = {
  fontFamily: "BasisGrotesque",
  fontSize: 8.5,
  lineHeight: 1.4,
};
// Create styles
const styles = StyleSheet.create({
  page: {
    display: "block",
    // flexDirection: 'column',
    backgroundColor: "#FFFFFF",
    padding: 40,
    paddingBottom: 100,
  },
  section: {
    fontFamily: "BasisGrotesque",
    marginLeft: "100px",
    width: "350px",
    marginBottom: 15,
    display: "block",
    ...body,
  },
  h1: {
    ...h1,
  },
  h2: {
    ...h2,
  },
  header: {
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 80,
  },
  smallCaps: {
    ...smallCaps,
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    flexDirection: "row",
    padding: 40,
    paddingBottom: 35,
    ...smallCaps,
  },
  footerCol1: {
    width: "100px",
  },
  footerCol: {
    marginRight: 20,
  },
  footerCol3: {
    marginLeft: "auto",
  },
  dimension: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 8,
    paddingBottom: 8,
    borderBottom: "0.5px solid grey",
  },
  swatchGrid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 10,
    transform: "translateX(-10px)",
  },
  swatch: {
    marginRight: 10,
    marginBottom: 20,
    textAlign: "center",
    display: "block",
    position: "relative",
    width: "60px",
    fontSize: 7,
  },
  swatchImage: {
    width: "40px",
    height: "40px",
    borderRadius: "999px",
    overflow: "hidden",
    marginBottom: "7px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  brandBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
  },
  brandText: {
    width: "250px",
    display: "block",
  },
  brandImage: {},
});

// Had to wrap it in a memo to stop it rerendering constantly and killing page performance

const ProductDocument = React.memo(({product}) => {
  const productContent = product?.content;
  return (
    <Document title={`${product?.title} _ Misura _ Technical Sheet`}>
      <Page size="A4" style={styles.page}>
        <View fixed style={styles.header}>
          <Logo />
          <Text
            style={styles.smallCaps}
            render={({pageNumber}) => `${("0" + pageNumber).slice(-2)}`}
          />
        </View>
        <View style={styles.section}>
          <Text style={styles.h1}>
            {product?.title} by {productContent?.brand?.title}
          </Text>
        </View>
        <View style={styles.section}>
          {productContent?.technicalSheetImage ? (
            <Image
              src={builder.image(productContent?.technicalSheetImage?.asset?.id)?.width(1400).url()}
            />
          ) : (
            <>
              {productContent?.images.filter((item) => item?.type === "productImage")?.length >
                0 && (
                <Image
                  src={builder
                    .image(
                      productContent?.images.filter((item) => item?.type === "productImage")[0]
                        ?.image?.asset?.id,
                    )
                    ?.width(1400)
                    .url()}
                />
              )}
            </>
          )}
        </View>
        <View style={{...styles.section, marginBottom: 30}}>
          <Text style={styles.h2}>Information</Text>
          {productContent?.information && (
            <Text>
              <BlockContent blocks={productContent?.information} />
            </Text>
          )}
        </View>
        {productContent?.dimensions?.map((dimensionBlock) => (
          <View style={styles.section} wrap={false} key={dimensionBlock?.title}>
            <Text style={{...styles.h2, marginBottom: 10}}>{dimensionBlock?.title}</Text>
            {dimensionBlock?.dimensions?.map((dimension, index) => (
              <View
                style={
                  index === 0
                    ? {...styles.dimension, borderTop: "0.5px solid grey"}
                    : styles.dimension
                }
                key={dimension?.title}
              >
                <Text style={styles.smallCaps}>{dimension?.title}</Text>
                <Text style={styles.smallCaps}>{dimension?.dimension}</Text>
              </View>
            ))}
          </View>
        ))}
        <View style={{...styles.section, marginTop: 10}}>
          <Text style={styles.h2}>Finishes</Text>
          {productContent?.finishesText && (
            <Text>
              <BlockContent blocks={productContent?.finishesText} />
            </Text>
          )}
        </View>
        {productContent?.finishes?.map((finish) => (
          <View style={styles.section} key={finish?.title}>
            <Text style={{...styles.h2, marginBottom: 20}}>{finish?.name}</Text>
            {finish?.sets?.map((set) => (
              <View style={styles.finishSet} key={set?.name} wrap={false}>
                <Text style={{...styles.smallCaps, marginBottom: 12}}>{set?.name}</Text>
                <View style={styles.swatchGrid}>
                  {set?.swatches?.map((swatch) =>
                    swatch._type === "swatch" ? (
                      <View style={styles.swatch} key={swatch?._key}>
                        <Image
                          style={styles.swatchImage}
                          src={
                            swatch?.image?.asset?.id
                              ? builder
                                  .image(swatch?.image?.asset?.id)
                                  ?.width(100)
                                  .height(100)
                                  .url()
                              : null
                          }
                        />
                        <Text>{swatch?.title}</Text>
                      </View>
                    ) : (
                      <View style={styles.swatch} key={swatch?._key}>
                        <Image
                          style={styles.swatchImage}
                          src={
                            swatch?.swatch?.image?.asset?.id
                              ? builder
                                  .image(swatch?.swatch?.image?.asset?.id)
                                  ?.width(100)
                                  .height(100)
                                  .url()
                              : null
                          }
                        />
                        <Text>{swatch?.swatch?.title}</Text>
                      </View>
                    ),
                  )}
                </View>
              </View>
            ))}
          </View>
        ))}
        <View style={{...styles.section, marginTop: 10}} wrap={false}>
          <Text style={styles.h2}>Brand</Text>
          <View style={styles.brandBlock}>
            <View style={styles.brandText}>
              <Text>
                <Text style={styles.smallCaps}>{productContent?.brand?.title}</Text>
                {"\n"}
                {productContent?.brand?.content?.shortText}
              </Text>
            </View>
            {productContent?.brand?.content?.image?.asset?.id && (
              <Image
                style={styles.brandImage}
                src={builder
                  .image(productContent?.brand?.content?.image?.asset?.id)
                  ?.width(600)
                  .url()}
              />
            )}
          </View>
        </View>
        {productContent?.features?.length > 0 && (
          <View style={{...styles.section, marginTop: 10}}>
            <Text style={styles.h2}>Features</Text>
          </View>
        )}
        {productContent?.features?.map((feature) => (
          <View style={{...styles.section, marginTop: 10}} wrap={false}>
            <Image
              style={styles.brandImage}
              src={builder.image(feature?.image?.asset).width(800).url()}
            />
            <Text style={{...styles.smallCaps, marginBottom: 5, marginTop: 12}}>
              {feature?.title}
            </Text>
            {feature?.text && (
              <Text>
                <BlockContent blocks={feature?.text} />
              </Text>
            )}
          </View>
        ))}
        <View fixed style={styles.footer}>
          <Text style={styles.footerCol1}>
            Sydney Showroom{"\n"}
            {"\n"}
            840 BOURKE STREET{"\n"}
            WATERLOO NSW 2017{"\n"}
            +61 02 8399 5630
          </Text>
          <Text style={styles.footerCol}>
            MELBOURNE SHOWROOM{"\n"}
            {"\n"}
            610 CHURCH STREET{"\n"}
            RICHMOND VIC 3121{"\n"}
            +61 03 9429 1221
          </Text>
          <Text style={styles.footerCol3}>
            {"\n"}
            {"\n"}
            ABN 11 604 623 958{"\n"}
            INFO@MISURA.COM.AU{"\n"}
            MISURA.COM.AU
          </Text>
        </View>
      </Page>
    </Document>
  );
});

export default ProductDocument;
